<template>
    <div>
        <SupplierForm v-if="showSupplierForm" :form-action="supplierFormAction" :supplier-id="editedSupplierId" @canceled="showSupplierForm = showSettingsForm = false"/>
        <SettingsForm v-else-if="showSettingsForm" :supplier-id="editedSupplierId" @canceled="showSettingsForm = showSupplierForm = false"/>
        <el-card v-else class="box-card">
            <el-row class="table-header">
                <span>Supplier</span>
                <el-button style="float: right; padding: 3px 0" type="text" @click="handleCreate">Hinzufügen</el-button>
            </el-row>
            <el-row></el-row>
            <el-row>
                <el-table
                        v-loading="loading"
                        :data="suppliers"
                        style="width: 100%">
                    <el-table-column
                            v-for="(col, index) in tableColumns"
                            :key="index"
                            :label="col.label"
                            :prop="col.prop"
                            align="center"
                            :formatter="col.formatter"
                            :width=getColumnWidth(col)>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            fixed="right"
                            width="120px">
                        <template slot-scope="scope">
                            <el-button
                                    @click="handleEdit(scope.row.id)"
                                    type="text"
                                    size="small">Bearbeiten</el-button>
                            <el-button
                                    @click="handleSettings(scope.row.id)"
                                    type="text"
                                    size="small">Einstellungen</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
        </el-card>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { FETCH_SUPPLIERS } from '../../../store/types';
    import SupplierForm from '../suppliers/SupplierForm';
    import SettingsForm from './SettingsForm';

    export default {
        name: 'Suppliers',
        components: { SettingsForm, SupplierForm },
        data () {
            return {
                loading: false,
                showSupplierForm: false,
                showSettingsForm: false,
                editedSupplierId: null,
                formAction: null,
            };
        },
        computed: {
            ...mapGetters(['get_suppliers', 'get_supplier', 'user_is_admin', 'get_current_user']),
            suppliers () {
                return this.get_suppliers;
            },
            tableColumns () {
                return [
                    { prop: 'id', label: 'ID', width: 80 },
                    { prop: 'supplier_name', label: 'Adresse' },
                    { prop: 'max_panels_per_customer', label: 'Zugelassene Anzahl von Panels pro Kunde' },
                    { prop: 'discount_per_panel', label: 'Rabatt pro Panel' },
                    { prop: 'contact_mail', label: 'Kontakt-Mail' },
                    { prop: 'mail_sender_address', label: 'Absender-Mail' },
                    { prop: 'font_color', label: 'Schriftfarbe' },
                    { prop: 'background_color', label: 'Hintergrundfarbe' },
                    { prop: 'highlight_color', label: 'Hervorhebungsfarbe' },
                ];
            },
        },
        created () {
            this.loading = true;
             this.$store.dispatch(FETCH_SUPPLIERS).then(() => {
                 this.loading = false;
             });
        },
        methods: {
            getColumnWidth (col) {
                return col.width || 'auto';
            },
            getSelectedSupplier () {
                let supplier;
                if (this.user_is_admin) {
                    supplier = this.get_supplier(this.editedSupplierId);
                } else {
                    supplier = this.get_supplier(this.get_current_user.supplier_id);
                }

                return supplier;
            },
            handleCreate () {
                this.supplierFormAction = 'create';
                this.showSupplierForm = true;
            },
            handleEdit (supplierId) {
                this.supplierFormAction = 'edit';
                this.showSupplierForm = true;
                this.editedSupplierId = supplierId;
            },
            handleSettings (supplierId) {
                this.showSettingsForm = true;
                this.editedSupplierId = supplierId;
            },
        },
    };
</script>
<style scoped>
    .table-header {
        margin-bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/suppliers/Suppliers.vue